import { lookupVin } from '@/apiCalls/assetLookup';
import { getBorrower } from '@/apiCalls/borrower';
import { trackWidgetRendered } from '@/apiCalls/uniqueIDTransferHelper';
import { EModals, setIsAssetKnownViaParams, setModal } from '@/context/display';
import { store } from '@/context/store'; // Add this import
import {
    ELocalStorageVariables,
    getLocalStorageItem,
} from '@/utils/localStorage';

async function handleSavedAppData(): Promise<void> {
    // Replace hooks with direct store dispatch and selectors
    const dispatch = store.dispatch;
    const state = store.getState();
    const partnerId = state.displayReducer.partner.id;
    const glassValuation = state.borrowerReducer.vehicle.glassValuation;

    if (!glassValuation && partnerId && partnerId !== 'UNKNOWN') {
        await lookupVin(partnerId).then((isSuccessful) => {
            if (isSuccessful) {
                dispatch(setIsAssetKnownViaParams(true));
            }
        });
    }

    // The silent restore is the recognition moment — but "returning" is a
    // claim about THIS partner, not about the borrower existing somewhere.
    // getBorrower returns the application for the current partner only, so an
    // application coming back is exactly "they have history here". A known
    // borrower opening a partner they have never used stays a first-timer on
    // that partner's dashboard.
    void getBorrower().then(() => {
        const application = store.getState().borrowerReducer.application;
        if (application.applicationId || application.id) {
            trackWidgetRendered('recognised', true);
        }
    });
    dispatch(setModal(null));
}

export function getInitialModalScreen(): EModals | null {
    const authToken = getLocalStorageItem(ELocalStorageVariables.AUTH_TOKEN);
    const firstName = getLocalStorageItem(ELocalStorageVariables.FIRST_NAME);

    if (authToken && firstName) {
        handleSavedAppData();
    }

    return null;
}
